/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var FtlSharedGeneratedApiFtlApplicationHandlersGetLauncherAppManifestResultArtifactType;
(function (FtlSharedGeneratedApiFtlApplicationHandlersGetLauncherAppManifestResultArtifactType) {
    FtlSharedGeneratedApiFtlApplicationHandlersGetLauncherAppManifestResultArtifactType["Unspecified"] = "Unspecified";
    FtlSharedGeneratedApiFtlApplicationHandlersGetLauncherAppManifestResultArtifactType["DirectLoad"] = "DirectLoad";
    FtlSharedGeneratedApiFtlApplicationHandlersGetLauncherAppManifestResultArtifactType["QbsPatch"] = "QbsPatch";
    FtlSharedGeneratedApiFtlApplicationHandlersGetLauncherAppManifestResultArtifactType["UnknownDefaultOpenApi"] = "11184809";
})(FtlSharedGeneratedApiFtlApplicationHandlersGetLauncherAppManifestResultArtifactType || (FtlSharedGeneratedApiFtlApplicationHandlersGetLauncherAppManifestResultArtifactType = {}));
export function instanceOfFtlSharedGeneratedApiFtlApplicationHandlersGetLauncherAppManifestResultArtifactType(value) {
    for (const key in FtlSharedGeneratedApiFtlApplicationHandlersGetLauncherAppManifestResultArtifactType) {
        if (Object.prototype.hasOwnProperty.call(FtlSharedGeneratedApiFtlApplicationHandlersGetLauncherAppManifestResultArtifactType, key)) {
            if (FtlSharedGeneratedApiFtlApplicationHandlersGetLauncherAppManifestResultArtifactType[key] === value) {
                return true;
            }
        }
    }
    return false;
}
export function FtlSharedGeneratedApiFtlApplicationHandlersGetLauncherAppManifestResultArtifactTypeFromJSON(json) {
    return FtlSharedGeneratedApiFtlApplicationHandlersGetLauncherAppManifestResultArtifactTypeFromJSONTyped(json, false);
}
export function FtlSharedGeneratedApiFtlApplicationHandlersGetLauncherAppManifestResultArtifactTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function FtlSharedGeneratedApiFtlApplicationHandlersGetLauncherAppManifestResultArtifactTypeToJSON(value) {
    return value;
}
export function FtlSharedGeneratedApiFtlApplicationHandlersGetLauncherAppManifestResultArtifactTypeToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=FtlSharedGeneratedApiFtlApplicationHandlersGetLauncherAppManifestResultArtifactType.js.map